import { Dispatch } from "redux"
import { AppStateWithData } from "../../.."
import { ApiConfig, createRequestActionTypes, createRequestThunk, RequestThunkParameters } from "../../../.."

export const deleteLabelActionTypes = createRequestActionTypes('DELETE_LABEL')

export interface DeleteLabelAdditionalData {
    collectionId: number,
    labelId: number
}
export type DeleteLabelResponse = {
    ok: boolean
}
export const deleteLabel = (config: ApiConfig) => (labelId: number, collectionId: number) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<DeleteLabelResponse, any, DeleteLabelAdditionalData> = {
        method: 'DELETE',
        requestActionTypes: deleteLabelActionTypes,
        url: `${config.API_URL}/collectionLabels/delete?labelId=${labelId}`,
        actionAdditionalData: {
            collectionId,
            labelId
        },
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}